import React, { Component } from 'react';
import { connect } from 'react-redux';
import AuthTemplate from 'components/templates/Auth';

class AuthTemplateContainer extends Component {
    render() {
        return (
            <AuthTemplate hideLogo={this.props.isWhitelabel} hideBackground={this.props.isWhitelabel}>
                {this.props.children}
            </AuthTemplate>
        );
    }
}

const mapStateToProps = state => ({
    isWhitelabel: state.router.isWhitelabel,
});

export default connect(mapStateToProps)(AuthTemplateContainer);



// WEBPACK FOOTER //
// ./src/containers/AuthTemplateContainer.js